import { classNames } from 'primereact/utils'

const avatar = {
    root: () => ({
        className: classNames(
            // Alignments
            'inline-flex items-center justify-center',
            'relative',
            // Sizes
            'w-10 h-10',
            //Shapes
            'rounded-full',
            // Colors
            'bg-faded-purple text-white'
        ),
    }),
}

export default avatar
